<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="row">
                            <div class="col">
                                <h4 class="card-title float-left" v-if="fixedExpense.id!=null">{{$t('finance.ipoteka.fixedExpenses.titleEdit')}}</h4>
                                <h4 class="card-title float-left" v-else>{{$t('finance.ipoteka.fixedExpenses.titleNew')}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.fixedExpenses.expenseType')}}:</label>
                                    <fixed-expense-type-select v-model="fixedExpense.expenseType"
                                                               @input="onExpenseTypeChange"
                                                               :placeholder="$t('finance.ipoteka.fixedExpenses.expenseType')">
                                    </fixed-expense-type-select>
                                    <div class="red" v-if="$v.fixedExpense.expenseType.$error">
                                        {{$t('finance.ipoteka.fixedExpenses.expenseType')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.fixedExpenses.fixedExpensePaymentPeriodType')}}:</label>
                                    <fixed-expense-payment-period-type-select v-model="fixedExpense.fixedExpensePaymentPeriodType"
                                                                              @input="onFixedExpensePaymentPeriodTypeChange"
                                                               :placeholder="$t('finance.ipoteka.fixedExpenses.fixedExpensePaymentPeriodType')">
                                    </fixed-expense-payment-period-type-select>
                                    <div class="red" v-if="$v.fixedExpense.fixedExpensePaymentPeriodType.$error">
                                        {{$t('finance.ipoteka.fixedExpenses.fixedExpensePaymentPeriodType')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.payDate')}}<span
                                            class="red">*</span></label>
                                    <custom-date-picker
                                            class="form-control"
                                            :disabledDates="{to: new Date('04/01/2020')}"
                                            v-model="fixedExpense.payDate"
                                            :date="fixedExpense.payDate"
                                            :clear-button="true">
                                    </custom-date-picker>
                                    <div class="red" v-if="$v.fixedExpense.payDate.$error">
                                        {{$t('finance.ipoteka.field.payDate')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>ТЎЛОВ САНАСИ: &nbsp;</label>
                                    <span class="red font-weight-bold">{{displayPeriodType}}</span>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.payAmount')}}<span class="red">*</span></label>
                                    <numeric-input :precision="2" v-model="fixedExpense.payAmount" :maxlength="8" @change="onPayAmountChange"></numeric-input>
                                    <div class="red" v-if="$v.fixedExpense.payAmount.$error">
                                        {{$t('finance.ipoteka.field.payAmount')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditPurpose')}}<span class="red">*</span></label>
                                    <textarea
                                            cols="30" rows="3"
                                            class="form-control"
                                            v-model="fixedExpense.creditPurpose"
                                            :class="{invalid : $v.fixedExpense.creditPurpose.$error}"
                                    ></textarea>
                                    <div class="red" v-if="!$v.fixedExpense.creditPurpose.minLength">
                                        Узунлиги 20 тадан кам булмаслиги керак
                                    </div>
                                    <div class="red" v-if="$v.fixedExpense.creditPurpose.$error">
                                        {{$t('finance.ipoteka.field.creditPurpose')}}
                                    </div>

                                </div>

                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditName')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="fixedExpense.creditName"
                                           :class="{invalid : $v.fixedExpense.creditName.$error}"/>
                                    <div class="red" v-if="$v.fixedExpense.creditName.$error">
                                        {{$t('finance.ipoteka.field.creditName')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditINN')}}<span class="red">*</span></label>
                                    <numeric-input2 v-model="fixedExpense.creditINN" :formatType="'String'" :maxlength="12" :placeholder="$t('finance.ipoteka.field.creditINN')">
                                    </numeric-input2>
                                    <!--<numeric-input :precision="0" v-model="fixedExpense.creditINN"></numeric-input>-->
                                    <div class="red" v-if="$v.fixedExpense.creditINN.$error">
                                        {{$t('finance.ipoteka.field.creditINN')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditAccount')}}<span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="fixedExpense.creditAccount"
                                           maxlength="20"
                                           :placeholder="$t('finance.ipoteka.field.creditAccount')"
                                           :class="{invalid : $v.fixedExpense.creditAccount.$error}"/>
                                    <div class="red" v-if="$v.fixedExpense.creditAccount.$error">
                                        {{$t('finance.ipoteka.field.creditAccount')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditMFO')}}<span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="fixedExpense.creditMFO"
                                           maxlength="5"
                                           :placeholder="$t('finance.ipoteka.field.creditMFO')"
                                           @change="onChangeMFO"
                                           :class="{invalid : $v.fixedExpense.creditMFO.$error}"/>
                                    <div class="red" v-if="!$v.fixedExpense.creditMFO.minLength">
                                        Узунлиги 5 тадан кам булмаслиги керак
                                    </div>
                                    <div class="red" v-if="$v.fixedExpense.creditMFO.$error">
                                        {{$t('finance.ipoteka.field.creditMFO')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditBankName')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="fixedExpense.creditBankName"
                                           disabled
                                           :class="{invalid : $v.fixedExpense.creditBankName.$error}"/>
                                    <div class="red" v-if="$v.fixedExpense.creditBankName.$error">
                                        {{$t('finance.ipoteka.field.creditBankName')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.operationType')}}: <span class="red">*</span> </label>
                                    <select class="form-control" v-model="fixedExpense.operationType" :class="{invalid : $v.fixedExpense.operationType.$error}">
                                        <option value="1">Обычная проводка</option>
                                        <!--<option value="2">Казначейский платеж</option>-->
                                    </select>
                                    <div class="red" v-if="$v.fixedExpense.operationType.$error">
                                        {{$t('finance.ipoteka.field.operationType')}}
                                    </div>
                                </div>
                                <div v-show="fixedExpense.operationType==2">
                                    <div class="form-group">
                                        <center><span class="text-center">Буджет</span></center>
                                        <hr color="black"/>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t('finance.ipoteka.field.nameBudget')}}<span
                                                class="red">*</span></label>
                                        <input type="text" class="form-control" v-model="fixedExpense.nameBudget"
                                               :placeholder="$t('finance.ipoteka.field.nameBudget')"
                                        />
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t('finance.ipoteka.field.codeBudget')}}<span
                                                class="red">*</span></label>
                                        <numeric-input2 v-model="fixedExpense.codeBudget" :formatType="'String'"
                                                        :maxlength="2"
                                                        :placeholder="$t('finance.ipoteka.field.codeBudget')">
                                        </numeric-input2>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t('finance.ipoteka.field.accountBudgetIncome')}}<span
                                                class="red">*</span></label>
                                        <numeric-input2 v-model="fixedExpense.accountBudgetIncome"
                                                        :formatType="'String'" :maxlength="2"
                                                        :placeholder="$t('finance.ipoteka.field.accountBudgetIncome')">
                                        </numeric-input2>
                                    </div>
                                    <div class="form-group">
                                        <label>{{$t('finance.ipoteka.field.innBudget')}}<span
                                                class="red">*</span></label>
                                        <numeric-input2 v-model="fixedExpense.innBudget" :formatType="'String'"
                                                        :maxlength="20"
                                                        :placeholder="$t('finance.ipoteka.field.innBudget')">
                                        </numeric-input2>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                                    {{$t("action.cancel")}}
                                </button>
                                <button class="all-btn add-btn" @click="save"
                                        :disabled="processing" v-if="save">
                                    {{$t("action.save")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required,minValue,minLength} from 'vuelidate/lib/validators';
    // import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    // import DatePicker from 'vuejs-datepicker';
    import {formatDate, parseDate, formatDateDay, formatDateMonth, formatDateWeek} from '@/shared/utils';
    import CustomDatePicker from '@/views/common/CustomDatePicker'
    import NumericInput2 from '@/views/common/NumericInput2'
    // import {BASE_API} from '@/axios';
    import FixedExpenseTypeSelect from "@/views/finance/debit/FixedExpenseTypeSelect";
    import FixedExpensePaymentPeriodTypeSelect from "@/views/finance/debit/FixedExpensePaymentPeriodTypeSelect";

    export default {
        name: "FixedExpensesAddEditView",
        components: {
            FixedExpensePaymentPeriodTypeSelect,
            CustomDatePicker,
            FixedExpenseTypeSelect,
            NumericInput2
        },
        data() {
            return {
                parseDate: parseDate,
                formatDate: formatDate,
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                ownerFilter: initFilterModel(),
                editIndex: null,
                loadingExcelCalc: false,
                fixedExpense: {
                    id: null,
                    // fixedExpensesName: null,
                    payDate: null,
                    payAmount: null,
                    creditName: null,
                    creditINN: null,
                    creditAccount: null,
                    creditBankName: null,
                    creditMFO: null,
                    documentNumber: null,
                    creditPurpose: null,
                    expenseType: null,
                    operationType: 1,
                    fixedExpensePaymentPeriodType: null,

                    codeBudget: null,
                    nameBudget: null,
                    accountBudgetIncome: null,
                    innBudget: null,
                },
                model: {
                    disabledDates:{}
                },
                provinces: [],
                itemFilter: initFilterModel(),
                results: null
            }
        },
        validations() {
            return {
                fixedExpense: {
                    expenseType: {
                        required: required
                    },
                    payDate: {
                        required: required
                    },
                    payAmount: {
                        required: required,
                        minValue: minValue(1)
                    },
                    creditName: {
                        required: required
                    },
                    creditINN: {
                        required: required
                    },
                    creditAccount: {
                        required: required
                    },
                    creditBankName: {
                        required: required
                    },
                    creditMFO: {
                        required: required,
                        minLength: minLength(5)
                    },
                    // documentNumber: {
                    //     required: required,
                    //     minLength: minLength(1)
                    // },
                    creditPurpose: {
                        required: required,
                        minLength: minLength(20)
                    },
                    fixedExpensePaymentPeriodType: {
                        required: required
                    },
                    operationType: {
                        required: required
                    },

                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.$http.get('/fixed-expense/view/' + id)
                        .then(res => {
                            console.log(res);
                            vm.fixedExpense = res.data;
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.fixedExpense.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            makePurpose() {
                const payAmount = this.fixedExpense.payAmount;
                const fixedExpensePaymentPeriodType = this.fixedExpense.fixedExpensePaymentPeriodType != null ? this.fixedExpense.fixedExpensePaymentPeriodType.displayName : '';
                let purpose = (this.fixedExpense.expenseType? this.fixedExpense.expenseType.name: '') + ' учун ' + payAmount + ' сум ' + this.formatDate(new Date()) + ' ' + fixedExpensePaymentPeriodType + ' тулов';
                return purpose;
            },
            onPayAmountChange() {
                if (!this.fixedExpense.id) {
                    this.fixedExpense.creditPurpose = this.makePurpose();
                }
            },
            onExpenseTypeChange() {
                if (!this.fixedExpense.id) {
                    this.fixedExpense.creditPurpose = this.makePurpose();
                }
            },
            onFixedExpensePaymentPeriodTypeChange() {
                if (!this.fixedExpense.id) {
                    this.fixedExpense.creditPurpose = this.makePurpose();
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                this.processing = true;
                this.$http.post('/fixed-expense/save', this.fixedExpense)
                    .then(res => {
                        console.log(res)
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.reEvaluation.success'),
                            type: 'success'
                        });
                        this.$router.push('/finance/ipoteka/fixed-expenses-list');
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.reEvaluation.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    })

            },
            onChangeMFO() {
                this.processing = true;
                console.log("this.fixedExpense.creditMFO = ");
                console.log(this.fixedExpense.creditMFO);
                if (this.fixedExpense.creditMFO.length >= 5) {
                    this.$http.get('/bank/mfo/' + this.fixedExpense.creditMFO)
                        .then(res => {
                            console.log(res);
                            if (res.data.status === "SUCCESS") {
                                this.fixedExpense.creditBankName = res.data.data.name;
                            } else {
                                this.fixedExpense.creditBankName = null;
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.common.errorOccurred') + '\n ' + res.data.message,
                                    type: 'error'
                                });
                            }
                            this.processing = false;
                        }, () => {
                            this.fixedExpense.creditBankName = null;
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.common.errorOccurred'),
                                type: 'error'
                            });
                            this.processing = false;
                        });
                } else {
                    this.fixedExpense.creditBankName = null;
                }
            },
            cancel() {
                this.$router.push('/finance/ipoteka/fixed-expenses-list');
            },
            showRemoveItemDialog(item) {
                this.$swal({
                   title: this.$t('messages.common.warning'),
                   text: this.$t('messages.reEvaluation.deleteConfirm'),
                   type: 'warning',
                   showCancelButton: true,
                   confirmButtonColor: '#dd3333',
                   confirmButtonText: 'Ўчириш',
                   cancelButtonText: 'Бекор қилиш'
                }).then((result) => {
                     if (result.value) {
                         this.editIndex = null;
                         this.reEvaluate.reEvaluationItems.splice(this.reEvaluate.reEvaluationItems.indexOf(item), 1);
                         this.initItemList()
                     }
                });
            },
        },
        computed: {
            displayPeriodType() {
                if (this.fixedExpense.fixedExpensePaymentPeriodType && this.fixedExpense.payDate) {
                    if (this.fixedExpense.fixedExpensePaymentPeriodType.code === 'FOR_EVERY_YEAR') {
                        return 'Хар йилнинг '+formatDateDay(parseDate(this.fixedExpense.payDate))
                            +'-'+ formatDateMonth(parseDate(this.fixedExpense.payDate)) + 'да';
                    } else if (this.fixedExpense.fixedExpensePaymentPeriodType.code === 'FOR_EVERY_MONTH') {
                        return 'Хар ойнинг ' + formatDateDay(parseDate(this.fixedExpense.payDate)) + '-санасида ';
                    } else if (this.fixedExpense.fixedExpensePaymentPeriodType.code === 'FOR_EVERY_WEAK') {
                        return 'Хар хафтанинг ' + formatDateWeek(parseDate(this.fixedExpense.payDate)) + ' куни';
                    }
                }
                return "";
            },
        },
        created() {
           this.init();
        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS",Arial,Helvetica,sans-serif;
        border-collapse: collapse;
        width: 100%;
    }
    .custom td,.custom th{
        border: 1px solid #ddd;
        padding: 4px;
    }
    .custom tr:nth-child(even){
        background-color: #f2f2f2;
    }
    .custom tr:hover{
        opacity: 1;
        background-color: #dee2e6;
    }
    .custom thead tr th{
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }
    .custom tr{
        font-size: 14px;
    }

</style>